import { URL } from "../store/utils";

/** Klinik logosu göreli `/assets/...` yolu ise API kökünü önüne ekler. */
export function resolveLogo(logoIconUrl) {
  if (!logoIconUrl) return null;
  return logoIconUrl.startsWith("/assets/")
    ? `${String(URL.url || "").replace(/\/+$/, "")}${logoIconUrl}`
    : logoIconUrl;
}
